import React from 'react';

export default function SectionHeader({ title, subtitle, variant = 'default' }) {
  if (variant === 'admin' || variant === 'card') {
    return (
      <h3 className="text-lg font-bold text-mono-900">{title}</h3>
    );
  }
  return (
    <div className="flex items-start gap-3">
      <div className="w-1 h-6 bg-orange-500 rounded-full shrink-0 mt-0.5" />
      <div>
        <h2 className="text-xl font-extrabold text-mono-900">{title}</h2>
        {subtitle && <p className="text-sm text-mono-500 mt-1">{subtitle}</p>}
      </div>
    </div>
  );
}
